import type { ReactNode } from "react";
import { ArtistIcon } from "../icons/ArtistIcon";

export interface SheetHeaderProps {
	readonly title: ReactNode;
	/** Leading affordance kind: `cancel` (text) or `back` (chevron). */
	readonly leading?: "cancel" | "back";
	readonly leadingLabel?: string;
	readonly onLeading?: () => void;
	readonly trailing?: ReactNode;
	readonly className?: string;
}

/**
 * SheetHeader — top header for slide-over sheets with a cancel/back leading
 * control and a centered title. Mirrors `DSSheetHeader` on iOS.
 */
export function SheetHeader({
	title,
	leading = "cancel",
	leadingLabel = "取消",
	onLeading,
	trailing,
	className = "",
}: Readonly<SheetHeaderProps>) {
	return (
		<header
			className={`ds-sheet-header ${className}`.trim()}
			style={{
				display: "grid",
				gridTemplateColumns: "52px minmax(0, 1fr) 52px",
				alignItems: "center",
				minHeight: "52px",
				padding: "var(--ds-space-sm) var(--ds-space-lg)",
			}}
		>
			<div style={{ display: "flex", justifyContent: "flex-start" }}>
				{onLeading === undefined ? null : leading === "back" ? (
					<button
						type="button"
						className="ds-icon-button"
						aria-label={leadingLabel}
						onClick={onLeading}
					>
						<ArtistIcon name="back" size={22} />
					</button>
				) : (
					<button
						type="button"
						onClick={onLeading}
						style={{
							border: 0,
							background: "none",
							color: "var(--ds-text-secondary)",
							font: "inherit",
							cursor: "pointer",
						}}
					>
						{leadingLabel}
					</button>
				)}
			</div>
			<h2
				style={{
					margin: 0,
					textAlign: "center",
					fontSize: "1rem",
					fontWeight: 650,
					color: "var(--ds-text-primary)",
				}}
			>
				{title}
			</h2>
			<div style={{ display: "flex", justifyContent: "flex-end" }}>
				{trailing}
			</div>
		</header>
	);
}
